module.exports = __webpack_public_path__ + "media/images/share-icon-6d4f4dc10fdc49b06fb724dcfebc6b95.png";